import { Container, Heading, Flex, Button, useBreakpointValue, Link } from '@chakra-ui/react';
import Image from 'next/image';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Arrow from '@/assets/icons/ic-arrow-down.svg';
import PresentationHeadingImage from '@/assets/images/presentation/presentation-heading.png';

import { Section } from '@/components/ui/core/Section/Section';
import { UNDERLINE_PARTNERS_ID } from '@/components/ui/features/presentation/PresentationPartners/PresentationPartners';

export const PresentationHeader: FC = () => {
  const objectPosition = useBreakpointValue({ base: '-850px', sm: '-600px', md: '-400px', lg: 'right' }, { ssr: true });
  const { t } = useTranslation();

  return (
    <Section height="530px" position="relative">
      <Container zIndex={1}>
        <Flex
          py={6}
          width={{ base: 'full', lg: '60%' }}
          h="full"
          flexDirection="column"
          justifyContent={{ base: 'flex-start', sm: 'center' }}
        >
          <Heading color="white">{t('newEventPage.headingPartOne')}</Heading>
          <Heading fontSize={{ base: 'lg', lg: '2xl' }} mt={6} color="white">
            {t('newEventPage.headingPartTwo')}
          </Heading>
          <Flex flexDirection={{ base: 'column', md: 'row' }} gap={4} mt={6}>
            <Link href={`#${UNDERLINE_PARTNERS_ID}`}>
              <Button variant="glass" color="white" alignSelf="flex-start" rightIcon={<Arrow />}>
                {t('landing.learnMoreButton')}
              </Button>
            </Link>
            <Link href="/contact-us/conferences">
              <Button
                variant="solid"
                bgColor="gray.50"
                color="black"
                _hover={{ bgColor: 'white', textDecoration: 'underline' }}
                alignSelf="flex-start"
              >
                Contact us
              </Button>
            </Link>
          </Flex>
        </Flex>
      </Container>
      <Image
        alt="presentation heading backgroun picture"
        src={PresentationHeadingImage}
        fill
        style={{ objectFit: 'cover', objectPosition }}
        role="presentation"
        loading="eager"
        priority
      />
    </Section>
  );
};
